// extracted by mini-css-extract-plugin
export var Author = "styles-module--Author--67d09";
export var Job = "styles-module--Job--4bea6";
export var Name = "styles-module--Name--79fea";
export var Pic = "styles-module--Pic--063b8";